
import React from "react";
import { BookMarked, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface EmptyStateProps {
  searchQuery: string;
  onRefresh: () => void;
}

export const SharedNotesEmptyState: React.FC<EmptyStateProps> = ({ 
  searchQuery, 
  onRefresh 
}) => {
  return (
    <div className="text-center py-12 border rounded-lg">
      <BookMarked className="h-12 w-12 mx-auto mb-4 text-muted-foreground" />
      <h3 className="text-lg font-medium mb-2">No public notes found</h3>
      <p className="text-muted-foreground mb-4">
        {searchQuery
          ? "No public notes match your search criteria"
          : "There are no public notes shared by other users yet"}
      </p>
      <Button onClick={onRefresh} variant="outline">
        <RefreshCw className="h-4 w-4 mr-2" />
        Refresh
      </Button>
    </div>
  );
};
